module.exports = __webpack_public_path__ + "static/media/12_calibre.9641102b.svg";